import { Feed } from 'views/self-service/features/feed-catalog/types/feed.type';
import { Treatment } from 'views/self-service/features/treatment-catalog/types/treatment.type';

export const editDuplicatedCode = (initialValues: Feed[] | Treatment[] | undefined, code: string, id?: number): boolean => {
  return typeof initialValues?.find((value) => value.id !== id && value.code === code) === 'object' ? true : false;
};
